export default __webpack_public_path__ + "static/media/flag-bouvet-island.ac315a4c.svg";